import { IFarm } from "./IFarm";

export interface IConsentClient {
  clientId: string;
  ownerName: string;
  purpose: string;
}

export interface IConsentClientItem {
  uuid: string;
  farm: Partial<IFarm>;
  client: IConsentClient;
  startDate?: string;
  endDate?: string;
  active?: boolean;
}

export type ConsentFetchOption = "FARM" | "CLIENT";

export const ConsentTypes = [
  "NONE",
  "ALL",
  "SELECTED",
  // "CONSENTED",
] as const;
export type ConsentType = (typeof ConsentTypes)[number];

export interface IConsentRequest {
  uuid: string;
  createdAt: string;
  consentClient: IConsentClient;
  status?: "REQUESTED" | "SENT";
}
